// src/services/queries/macro/fxCommoditiesQueries.ts

import type { QueryFunction } from "@tanstack/react-query";
import { macroQueryKeys } from "@/constants/queryKeys";
import { TIME } from "@/constants/app";
import { API_BASE_URL } from "@/services";
import type { FxCommoditiesResponse } from "@/types/dashboards/macro";

/**
 * Fetch FX and commodities data from backend API
 */
export const fetchFXCommodities: QueryFunction<FxCommoditiesResponse> = async ({
  signal,
}) => {
  const requestInit: RequestInit = {};
  if (signal) {
    requestInit.signal = signal;
  }

  const response = await fetch(
    `${API_BASE_URL}/macroIndicators/fxCommodities`,
    requestInit
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = (await response.json()) as FxCommoditiesResponse;
  return data;
};

// Query options factory
export const fxCommoditiesQueryOptions = () => ({
  queryKey: macroQueryKeys.fxCommodities(),
  queryFn: fetchFXCommodities,
  staleTime: 5 * TIME.MINUTE, // 5 minutes
  gcTime: 10 * TIME.MINUTE, // 10 minutes
  retry: 2,
  retryDelay: (attemptIndex: number) =>
    Math.min(1000 * 2 ** attemptIndex, 30000),
});
